<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.items' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="updateProduct()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-10">

          <!-- ===== Row 1 ===== -->
   <div class="row">
  <!-- Category -->
  <div class="col-md-6 mb-3">
    <label class="form-label fw-medium">
      {{ lang == 'ar' ? 'التصنيف' : 'Category' }}
    </label>
    <select
      class="form-control"
      [(ngModel)]="product.category_id"
      name="category_id"
      required
    >
      <option [value]="null" disabled>
        {{ lang == 'ar' ? 'اختر التصنيف' : 'Select Category' }}
      </option>
      <option *ngFor="let cat of arrCoupons" [value]="cat.id">
        {{ cat.name }}
      </option>
    </select>
  </div>

  <!-- Active Toggle -->
  <div class="col-md-6 mb-3">
    <label class="form-label fw-medium">
      {{ lang == 'ar' ? 'مفعل' : 'Active' }}
    </label>
    <select
      class="form-control"
      [(ngModel)]="product.is_active"
      name="is_active"
    >
      <option [value]="true">{{ lang == 'ar' ? 'مفعل' : 'Active' }}</option>
      <option [value]="false">{{ lang == 'ar' ? 'غير مفعل' : 'Inactive' }}</option>
    </select>
  </div>
</div>

<!-- ===== Row 2 ===== -->
<div class="row">
  <!-- Title -->
  <div class="col-md-6 mb-3">
    <label class="form-label fw-medium">
      {{ lang == 'ar' ? 'العنوان' : 'Title' }}
    </label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="product.title"
      name="title"
    />
  </div>

  <!-- Content -->
  <div class="col-md-6 mb-3">
    <label class="form-label fw-medium">
      {{ lang == 'ar' ? 'المحتوى' : 'Content' }}
    </label>
    <textarea
      class="form-control"
      [(ngModel)]="product.content"
      name="content"
      rows="3"
    ></textarea>
  </div>
</div>

<!-- ===== Row 3 ===== -->
<div class="row">
  <!-- Count -->
  <div class="col-md-3 mb-3">
    <label class="form-label fw-medium">
      {{ lang == 'ar' ? 'العدد' : 'Count' }}
    </label>
    <input
      type="number"
      min="1"
      class="form-control"
      [(ngModel)]="product.count"
      name="count"
    />
  </div>

  <!-- Reference -->
  <!-- <div class="col-md-3 mb-3">
    <label class="form-label fw-medium">
      {{ lang == 'ar' ? 'المرجع' : 'Reference' }}
    </label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="product.reference"
      name="reference"
    />
  </div> -->

  <!-- Order -->
  <div class="col-md-3 mb-3">
    <label class="form-label fw-medium">
      {{ lang == 'ar' ? 'الترتيب' : 'Order' }}
    </label>
    <input
      type="number"
      min="0"
      class="form-control"
      [(ngModel)]="product.order"
      name="order"
    />
  </div>
</div>

          <!-- ===== Submit ===== -->
          <div class="d-flex justify-content-end mt-4">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Save_Changes' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>
</div>
